import React, { useEffect, useRef, useState, useContext } from "react";
import "./widgetcss/styles.css";
import { MapContext } from "../MapContext";

export default function DataInfo ({mapValue}) {
  const [showCard, setShowCard] = useState(false);
  const infoCardRef = useRef(null);
  const mapContext = useContext(MapContext);

  const handleClick = (event) => {
    // Infocard ijungtas
    //return
    const clickedInsideCard = infoCardRef.current && infoCardRef.current.contains(event.target);
    const clickedMapView = event.target.closest(".mapDiv.esri-view");
    
    if (!showCard && clickedMapView && mapContext.state.dataInfoCardShown < 3) {
       console.log(mapContext.state.dataInfoCardShown, mapValue);
      if (mapValue === 0 && mapContext.state.dataInfoCardShown % 2 !== 1) {
        mapContext.dispatch({
            dataInfoCardShown: mapContext.state.dataInfoCardShown  + 1,
        
      }); 
      setShowCard(true);
      } else if (mapValue === 4 &&  mapContext.state.dataInfoCardShown < 2) {
        mapContext.dispatch({
            dataInfoCardShown: mapContext.state.dataInfoCardShown + 2,
      }); 
      setShowCard(true);
      }
      // show the card if clicked on .mapDiv.esri-view
    } else if (showCard && !clickedInsideCard) {
      // Optionally hide card if clicked outside, remove this block if not needed
      // setShowCard(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClick);
    return () => {
      document.removeEventListener("mousedown", handleClick);
    };
  }, [showCard]);

  return (
    <>
      {showCard ? (
        <div id="ErrorCard" ref={infoCardRef}>
          <div
            id="InfoCardClose"
            onClick={() => setShowCard(false)}
          >
            X
          </div>
          <div id="ErrorCardTtile">Dėmėsio!</div>
          <br />
          {mapValue === 0 ? <> Nuo 2025-09-01 pateikiami ekstrapoliuoti automobilių srautų duomenys </>:
          <>
          Stotelių pasiekiamumo analizė atilkta 1km spindulių nuo stotelės.</>
          }
        </div>
      ) : <></>}
    </>
  );
}
